import moment from "moment"
import { CustomMultiSelectModel } from "../../../components/CustomMultiSelect"
import { CustomSingleSelectModel } from "../../../components/CustomSingleSelect"
import { ColumnChooserModel } from "../../common/ColumnChooserModel"
import { ColumnFilterModel } from "../../common/ColumnFilterModel"

export interface GetAntrepoOfferListPagingAndFilterRequest {
    searchTerm: string
    skip: number
    take: number
    currentPage: number
    sortColumn?: string
    sortDirection?: string
    columnChooser: ColumnChooserModel[] | undefined
    antrepoOfferStartDateStart: string | undefined
    antrepoOfferStartDateEnd: string | undefined
    antrepoOfferEndDateStart: string | undefined
    antrepoOfferEndDateEnd: string | undefined
    antrepoOfferCreatedDateStart: string | undefined
    antrepoOfferCreatedDateEnd: string | undefined
    selectedCustomer: CustomSingleSelectModel | undefined
    selectedAntrepoOfferStatus: CustomMultiSelectModel[]
    /** Kolon başlıklarının altındaki filtreler. */
    columnFilters: ColumnFilterModel[]
    /** Excel "Seçilenler" için işaretli kayıtlar. */
    ids?: string[]
}

export const initialGetAntrepoOfferListPagingAndFilterRequest: GetAntrepoOfferListPagingAndFilterRequest = {
    searchTerm: '',
    skip: 0,
    take: 50,
    currentPage: 1,
    sortColumn: undefined,
    sortDirection: undefined,
    columnChooser: undefined,
    antrepoOfferEndDateEnd: undefined,
    antrepoOfferEndDateStart: undefined,
    antrepoOfferStartDateEnd: undefined,
    antrepoOfferStartDateStart: undefined,
    // Son bir aylık oluşturma tarihi varsayılanı artık "Oluşturma Tarihi" kolon filtresi.
    antrepoOfferCreatedDateStart: undefined,
    antrepoOfferCreatedDateEnd: undefined,
    selectedCustomer: undefined,
    selectedAntrepoOfferStatus: [],
    columnFilters: [
        { column: 'createdDateStr', from: moment(new Date()).subtract(1, 'month').format("YYYY-MM-DD"), to: moment(new Date()).format("YYYY-MM-DD") }
    ],
    // selectedMeetingCompanyTypes: [{ label: 'Potansiyel Müşteri', value: '', additionalValue1: '1' }]
}